<template>
    <div class="splash-container" v-if="recoverPassword" ref="passwordForm">
        <figure>
            <img src="/wp-content/uploads/2018/10/page-icon.png" alt="">
        </figure>
        <div class="splash-info">
            <div v-if="!recoverPasswordSuccess">
                <h2>Olvidó su contraseña?</h2>
                <strong>Ingrese su correo electrónico para reiniciar su clave.</strong>
                <p>De no llegarle la notificación de cambio de clave al inbox de su correo, es importante que revise el folder de correo basura (Spam).</p>
                <form @submit.prevent="changePassword">
                    <div class="form-row">
                        <div class="col-md-12">
                            <label for="" class="form-label">Correo electrónico *</label>
                            <input v-model="email" v-validate="'required|email'" name="email" class="form-control" :class="{ 'is-invalid': submitted && errors.has('email') }" id="inputEmail" placeholder="nombre@email.com">
                            <div v-if="submitted && errors.has('email')" class="invalid-feedback">{{ errors.first('email') }}</div>
                        </div>
                    </div>
                    <button class="default-button default-button-form">Enviar nueva contraseña</button>
                </form>
            </div>
            <div v-if="recoverPasswordSuccess">
                <h2>Contraseña enviada</h2>
                <strong>Por favor revise su correo electrónico</strong>
                <p>De no llegarle la notificación de cambio de clave al inbox de su correo, es importante que revise el folder de correo basura (Spam).</p>
                <button class="default-green" @click="closeSplash">Regresar</button>
            </div>
        </div>
    </div>
</template>

<script>
import * as CrboxApi from '../../services/CrboxApi.js';

export default {
    props: ['recoverPassword'],
    data() {
        return{
            email: '',
            recoverPasswordSuccess: false
        }
    },
    methods: {
        changePassword() {
            this.submitted = true;
            this.$validator.validate().then(valid => {
                let loader = this.$loading.show({
                    container: this.$refs.passwordForm
                });
                CrboxApi.getPasswordRecovery(this, this.email)
                .then((response) => {
                    if(response.data.Message == "OK"){
                        this.recoverPasswordSuccess = true;
                    }else if(response.data.Message == "FALSE"){
                        this.$notify({
                            group: 'notifications',
                            type: 'warn',
                            title: 'Recuperar contraseña',
                            text: "El usuario no existe en el sitema",
                            duration: 4000,
                            speed: 1000
                        })
                    }
                    loader.hide();                     
                })
                .catch(()=>{
                    this.$notify({
                        group: 'notifications',
                        type: 'error',
                        title: 'Recuperar contraseña',
                        text: "Ocurrió un error al tratar de recuperar la contraseña",
                        duration: 4000,
                        speed: 1000
                    })
                    loader.hide(); 
                })
            }) 
        },
        closeSplash() {
            this.recoverPassword = false;
            this.$emit('changedSuccesfully', this.recoverPassword);
        }
    }
}
</script>
